import React from 'react';
import _ from 'lodash';
import { useGetAllActiveMerchantsIdAndNameCachedQuery } from '../../../redux/commonApiCalls';
import AbdSearchableSelect from './AbdSearchableSelect';

/**
 * V2-only merchant filter. Local fork of the shared
 * {@code MerchantFilterCached} so the V2 filter bar can pass label /
 * placeholder / size without modifying the shared component used by 30+
 * other pages.
 */
export default function AbdMerchantFilter({
    required = false,
    merchantType = null,
    fullWidth = true,
    label = 'Select Merchant',
    placeholder,
    size,
}) {
    const { data: merchants = [] } = useGetAllActiveMerchantsIdAndNameCachedQuery();
    let activeMerchant = merchants.filter((val) => val.is_deleted === '0');
    if (merchantType) {
        activeMerchant = activeMerchant.filter((val) => val[merchantType] === true);
    }
    return (
        <AbdSearchableSelect
            fullWidth={fullWidth}
            name='merchant'
            label={label}
            placeholder={placeholder}
            size={size}
            required={required}
            options={_.orderBy(activeMerchant, 'name').map((val) => ({
                value: val.id,
                label: val.companyName ? `${val.name} (${val.companyName})` : val.name,
            }))}
        />
    );
}
